const defaultSupervisorUserOption = null;

export default defaultSupervisorUserOption;
